// JavaScript Document
/* ================================================================== */
/*      FIRSTVIEW
/* ================================================================== */
document.querySelectorAll(".photo_box").forEach(function (element, index) {

  setTimeout(function () {

    new Swiper(element, {
      loop: true,
      effect: 'slide',
      parallax: true,
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 0,
      speed: 1000,

      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      }
    });

  }, index * 2000); // 2秒ずつ開始をずらす

});